import { FileCommand } from 'app/projects/core/src/lib/models/file.command';

export class TenantImageUploadCommand extends FileCommand {
    constructor(imageId: string, file: File) {
        super('file', file);

        this.formData.append('image_id', imageId);
    }
}
